import React from 'react'
import Resx from '@/components/Resx'
import Icon from '@/components/Icon'
import { Link } from 'react-router-dom'
import kebabCase from 'lodash/kebabCase'
import { Button } from '@/components/button'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { useLocalization } from '@/hooks/localization'

function ChangeItem ({ item, deleteChangeItem, canViewCHR, task }) {
  const { localize } = useLocalization()
  const openErrorDialog = () => {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.validationErrors,
      errorInfo: item.validationErrors
    }))
  }
  const openAlertDialog = () => {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.alert,
      title: localize('Tasks:MinMergeCompaniesExceededTitle'),
      content: localize('Tasks:MinMergeCompaniesExceededContent')
    }))
  }

  const isValidTaskType = task && task.type && (task.type.code === 'AssignMergedCompanies' || task.type.code === 'ManageMergedCompanies')
  const changeItem = task && task.changeRequest.items[0]
  const isTaskValid = isValidTaskType && task && task.changeRequest && task.changeRequest.items && task.changeRequest.items[0]
  let modifiedDataParsed = null
  if (isTaskValid) {
    if (typeof changeItem.modifiedData === 'string') {
      try {
        modifiedDataParsed = JSON.parse(changeItem.modifiedData)
      } catch (error) {
        console.error('Failed to parse JSON:', error)
        modifiedDataParsed = {}
      }
    } else {
      modifiedDataParsed = changeItem.modifiedData
    }
  }

  let mergedCompaniesParsed = []
  if (modifiedDataParsed && modifiedDataParsed.mergedCompanies) {
    mergedCompaniesParsed = modifiedDataParsed.mergedCompanies
  }

  let minimumInstitutions = 0
  if (modifiedDataParsed) {
    minimumInstitutions = modifiedDataParsed.minimumInstitutionsOverride || (modifiedDataParsed.class ? modifiedDataParsed.class.minimumInstitutions : 0) || 0
  }

  const crossedMinCompaniesNumber = mergedCompaniesParsed.length > minimumInstitutions

  return (
    <tr key={item.id}>
      <td>{canViewCHR &&
        <Link to={`/${kebabCase(item.scope)}/~${item.id}`}><Icon name={deleteChangeItem ? 'edit' : 'show'} /></Link>}
      </td>
      <td><Resx name={item.targetId ? 'Tasks.ChangeItemModification' : 'Tasks.ChangeItemInsert'} /></td>
      <td>{item.name}</td>
      <td>{item.validationErrorsCount > 0
        ? <Button onClick={openErrorDialog} className='red d-flex align-items-center'><Icon name='error' />&nbsp;{item.validationErrorsCount}x</Button>
        : <Icon name='check green' />
      }</td>
      {crossedMinCompaniesNumber &&
        <td className='validation-status'><Button onClick={openAlertDialog} className='orange align-items-center inline-flex'><Icon name='error' />&nbsp;</Button>
        </td>}
      {!!deleteChangeItem && <td><Button
        onClick={() => deleteChangeItem(item.id)}
        confirmText='Tasks.ConfirmRemoveChangeItem'
        confirmTitle='Tasks.ConfirmRemoveChangeItemTitle'
        icon='x' iconOnly />
      </td>}
    </tr>
  )
}

export default ChangeItem



// WEBPACK FOOTER //
// ./src/internal-app/pages/tasks/changeItem.js